
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkDocumenttypeIdentifierNameEnum } from '../models/work-documenttype-identifier-name-enum';

export function getUpdateDocumentV2DtoFormGroup() {
return new FormGroup({
    file: new FormControl<string | undefined>(undefined),
    documenttypeId: new FormControl<number | undefined>(undefined),
    documentsubtypeId: new FormControl<number | undefined>(undefined),
    documentTypeIdentifierName: new FormControl<WorkDocumenttypeIdentifierNameEnum | undefined>(undefined),
    contactId: new FormControl<number | undefined>(undefined),
    userId: new FormControl<number | undefined>(undefined),
    projectId: new FormControl<number | undefined>(undefined),
    itemId: new FormControl<number | undefined>(undefined),
    calculationitemId: new FormControl<number | undefined>(undefined),
    orderId: new FormControl<number | undefined>(undefined),
    prospectId: new FormControl<number | undefined>(undefined),
    assignedTo: new FormControl<number | undefined>(undefined),
    prettyName: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    folder: new FormControl<string | undefined>(undefined, [Validators.maxLength(100)]),
    active: new FormControl<boolean | undefined>(undefined),
    statusId: new FormControl<number | undefined>(undefined),
    created: new FormControl<string | undefined>(undefined),
    processingStatus: new FormControl<string | undefined>(undefined),
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(500)]),
})
;
}
      